import { PermissionsFn } from '~/core/PermissionGuard';

// Exports
export const permissions: PermissionsFn = (context) => {
  if (context.user.organization.slug === 'valleyBank') return 'deny';
  return context.flags.productsLoansPermissions;
};

export const editPermissions: PermissionsFn = (context) => {
  if (context.user.organization.slug === 'valleyBank') return 'deny';
  return context.flags.productsLoansEditPermissions;
};
